import * as brokerHooks from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import PropertyListItemHeader, {
  IPropertyListAddressSortProps,
  PropertyListItemItem,
  PropertyListItemSpacer,
} from "../PropertyListItem/PropertyListItem.header";
import { ESortOrder, OrderChangeFunction } from "../SortableResourceListHeader";
import {
  WIDTH_CONTRACT_DATE,
  WIDTH_OWNERS,
  WIDTH_TENANTS,
} from "./PropertyListItemRentExit.constants";
import * as S from "./PropertyListItemRentExit.styles";

const statuses: string[] = [
  "system.release_rent_deposit",
  "system.outstanding_payments",
  // "system.rentio_move",
  "system.outgoing_location_description",
];
interface IPropertyListItemRentHeaderProps
  extends IPropertyListAddressSortProps {
  contractStartDateOrder: ESortOrder | undefined;
  contractStartDateOnOrderChange: OrderChangeFunction;
}

const PropertyListItemRentExitHeader = ({
  addressOrder,
  addressOnChangeOrder,
  contractStartDateOrder,
  contractStartDateOnOrderChange,
  selectable,
}: IPropertyListItemRentHeaderProps) => {
  const hasRentioMoveForBroker = brokerHooks.useBrokerFeature(
    EBrokerFeature.RentioMove,
  );

  const statusConditions: Record<string, boolean> = {
    "system.rentio_move": hasRentioMoveForBroker,
  };

  // Render
  return (
    <PropertyListItemHeader
      addressOrder={addressOrder}
      addressOnChangeOrder={addressOnChangeOrder}
      selectable={selectable}
    >
      <PropertyListItemItem
        text={getLocalizedText("properties.owners")}
        style={{ width: WIDTH_OWNERS }}
        contentStyle={{ justifyContent: "center" }}
      />

      <PropertyListItemSpacer />

      <PropertyListItemItem
        text={getLocalizedText("properties.tenants")}
        style={{ width: WIDTH_TENANTS }}
      />

      <S.StartDateWrap>
        <PropertyListItemItem
          style={{
            width: WIDTH_CONTRACT_DATE,
          }}
          text={getLocalizedText("contract.enddate")}
          sortable={{
            order: contractStartDateOrder,
            onOrderChange: contractStartDateOnOrderChange,
          }}
        />
      </S.StartDateWrap>

      <PropertyListItemSpacer />

      {statuses
        .filter(status => statusConditions[status] ?? true)
        .map(key => (
          <PropertyListItemItem
            key={key}
            text={getLocalizedText(`${key}.short`)}
            tooltipContent={getLocalizedText(key)}
            style={{ flex: 1 }}
            contentStyle={{ justifyContent: "center" }}
          />
        ))}
    </PropertyListItemHeader>
  );
};

// eslint-disable-next-line import/no-default-export
export default PropertyListItemRentExitHeader;
